import { Link } from "react-router-dom";
import { Package, MapPin, Phone, Mail, MessageCircle, Leaf } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#3E2723] text-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="mb-6">
            <div className="inline-flex bg-white/90 rounded-lg px-3 py-2">
              <img src="https://customer-assets-jt897jd0.emergentagent.net/job_todo-carton-refresh/artifacts/djv40jun_B13344D7-2AA4-4B1D-AE94-ED9395AD1108.webp" alt="Todo de Cartón" className="h-12 w-auto object-contain" />
            </div>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed">
            Más de 50 años siendo líderes en productos de cartón reciclado y servicios de mensajería en México.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="#" className="w-10 h-10 bg-stone-800 rounded-full flex items-center justify-center hover:bg-[#2E7D32] transition-colors" data-testid="social-whatsapp">
              <MessageCircle size={20} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-6">Servicios</h4>
          <ul className="space-y-3">
            <li><Link to="/servicios" className="text-stone-400 hover:text-white transition-colors">Mensajería Nacional</Link></li>
            <li><Link to="/guias-prepago" className="text-stone-400 hover:text-white transition-colors">Guías Prepago</Link></li>
            <li><Link to="/archivo-digital" className="text-stone-400 hover:text-white transition-colors">Archivo Muerto Digital</Link></li>
            <li><Link to="/cotizar" className="text-stone-400 hover:text-white transition-colors">Cotizador de Envíos</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-6">Empresa</h4>
          <ul className="space-y-3">
            <li><Link to="/tienda" className="text-stone-400 hover:text-white transition-colors">Tienda</Link></li>
            <li><Link to="/franquicias" className="text-stone-400 hover:text-white transition-colors">Franquicias</Link></li>
            <li><Link to="/contacto" className="text-stone-400 hover:text-white transition-colors">Contacto</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-6">Contacto</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <MapPin size={20} className="text-[#F57C00] flex-shrink-0 mt-1" />
              <span className="text-stone-400 text-sm">Ciudad de México, México</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={20} className="text-[#F57C00]" />
              <span className="text-stone-400 text-sm">+52 55 1234 5678</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={20} className="text-[#F57C00]" />
              <span className="text-stone-400 text-sm">info@tododecarton.com.mx</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-stone-500 text-sm">© 2024 Todo de Cartón. Todos los derechos reservados.</p>
        <div className="flex items-center gap-2 text-stone-500 text-sm">
          <Leaf size={16} className="text-[#4CAF50]" />
          <span>Empresa comprometida con el medio ambiente</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
